var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_25550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 27.333H52.3333C53.6667 27.333 55 28.333 55 29.9997C55 31.6663 54 32.6663 52.3333 32.6663H27.3333C26 32.6663 25 31.333 25 29.9997C25 28.6663 26 27.333 27.3333 27.333Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 17.333H52.3333C53.6667 17.333 55 18.333 55 19.9997C55 21.6663 54 22.6663 52.3333 22.6663H27.3333C26 22.6663 25 21.333 25 19.9997C25 18.6663 26 17.333 27.3333 17.333Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3334 42.6663H52.3334C53.6667 42.6663 55.0001 41.6663 55.0001 39.9997C55.0001 38.333 54.0001 37.333 52.3334 37.333H27.3334C26.0001 37.333 24.6667 38.333 24.6667 39.9997C24.6667 41.6663 26.0001 42.6663 27.3334 42.6663Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3334 52.6663H52.3334C53.6667 52.6663 55.0001 51.6663 55.0001 49.9997C55.0001 48.333 54.0001 47.333 52.3334 47.333H27.3334C26.0001 47.333 24.6667 48.333 24.6667 49.9997C24.6667 51.6663 26.0001 52.6663 27.3334 52.6663Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3334 62.6663H52.3334C53.6667 62.6663 55.0001 61.6663 55.0001 59.9997C55.0001 58.333 54.0001 57.333 52.3334 57.333H27.3334C26.0001 57.333 24.6667 58.333 24.6667 59.9997C24.6667 61.6663 26.0001 62.6663 27.3334 62.6663Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 59.6667C11.6666 59.6667 10.3333 58.6667 10.3333 57V46.6667C10.3333 45.3333 11.3333 44 12.9999 44C14.6666 44 15.6666 45 15.6666 46.6667V57C15.3333 58.6667 14.3333 59.6667 12.9999 59.6667Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9999 59.6667C65.6666 59.6667 64.3333 58.6667 64.3333 57V46.6667C64.3333 45.3333 65.3333 44 66.9999 44C68.6666 44 69.6666 45 69.6666 46.6667V57C69.6666 58.6667 68.3333 59.6667 66.9999 59.6667Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 35.6663C11.6666 35.6663 10.3333 34.6663 10.3333 32.9997V22.9997C10.3333 21.6663 11.3333 20.333 12.9999 20.333C14.6666 20.333 15.6666 21.333 15.6666 22.9997V33.333C15.3333 34.6663 14.3333 35.6663 12.9999 35.6663Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9999 35.6663C65.6666 35.6663 64.3333 34.6663 64.3333 32.9997V22.9997C64.3333 21.6663 65.3333 20.333 66.9999 20.333C68.6666 20.333 69.6666 21.333 69.6666 22.9997V33.333C69.6666 34.6663 68.3333 35.6663 66.9999 35.6663Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 11.6667C65.6667 11.6667 64.3333 10.6667 64.3333 9.33333C64.3333 7 62.6667 5.33333 60.3333 5C59 5 58 3.66667 58 2.33333C58 1 59.3333 0 60.6667 0C65.6667 0.333333 69.3333 4.33333 69.3333 9C69.6667 10.6667 68.3333 11.6667 67 11.6667Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 9.33301C10.3333 4.33301 14.3333 0.333008 18.9999 0.333008C20.3333 0.333008 21.6666 1.33301 21.6666 2.66634C21.6666 3.99967 20.6666 5.33301 19.3333 5.33301C16.9999 5.33301 15.3333 7.33301 15.3333 9.66634C15.3333 10.9997 14.3333 11.9997 12.6666 11.9997C10.9999 11.9997 10.3333 10.6663 10.3333 9.33301Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 5H34.6667C33.3333 5 32 4 32 2.33333C32 0.666667 33.3333 0 35 0H45.3333C46.6667 0 48 1 48 2.66667C48 4.33333 46.6667 5 45 5Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 68.333C14.3332 68.333 15.6666 69.333 15.6666 70.6663C15.6666 72.9997 17.3332 74.6663 19.6666 74.9997C20.9999 74.9997 21.9999 76.333 21.9999 77.6663C21.9999 78.9997 20.6666 79.9997 19.3332 79.9997C14.3332 79.6663 10.6666 75.6663 10.6666 70.9997C10.3332 69.333 11.6666 68.333 12.9999 68.333Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6666 70.9997C69.6666 75.9997 65.6666 79.9997 60.9999 79.9997C59.6666 79.9997 58.3333 78.9997 58.3333 77.6663C58.3333 76.333 59.3333 74.9997 60.6666 74.9997C62.9999 74.9997 64.6666 72.9997 64.6666 70.6663C64.6666 69.333 65.6666 68.333 67.3333 68.333C68.9999 68.333 69.6666 69.333 69.6666 70.9997Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 75H45.3333C46.6667 75 48 76 48 77.6667C48 79.3333 46.6667 80 45 80H34.6667C33.3333 80 32 79 32 77.3333C32 75.6667 33.3333 75 35 75Z",
    fill: "#DDDDDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_25550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListEmpty);
export default __webpack_public_path__ + "static/media/icon_list_empty.127227ecaeef6f9a09c7df7243c9e058.svg";
export { ForwardRef as ReactComponent };